import React from "react"
import Typography from "@material-ui/core/Typography"
import Paper from "@material-ui/core/Paper"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import ListItemText from "@material-ui/core/ListItemText"
import DoneIcon from "@material-ui/icons/Done"
import ErrorIcon from "@material-ui/icons/Error"

const ThreeAsOne = ({ classes, name, cpf, email }) => {
    return (
        <div className={classes.bigContainer}>
            <Paper className={classes.paper}>
                <div>
                    <div style={{ marginBottom: 32 }}>
                        <Typography variant="h4">
                            Confirmação de Inscrição
            </Typography>
                    </div>
                    <div>
                        <List>
                            <Typography color="secondary">
                                Tipo da Inscrição
            </Typography>
                            <ListItem>
                                <ListItemIcon>
                                    <DoneIcon
                                        width={100}
                                    />
                                </ListItemIcon>
                                <ListItemText>
                                    Participante
                </ListItemText>
                            </ListItem>
                            <Typography color="secondary">
                                Nome do Participante
                </Typography>
                            <ListItem style={{ wordWrap: 'break-word' }}>
                                <ListItemIcon>
                                    {name ? (
                                        <DoneIcon
                                            width={100}
                                        />
                                    ) :
                                        <ErrorIcon
                                            width={100}
                                        />
                                    }
                                </ListItemIcon>
                                <ListItemText>
                                    {!name ? ('Nome inválido') : name}
                                </ListItemText>
                            </ListItem>

                            <Typography color="secondary">
                                CPF do Participante
                </Typography>
                            <ListItem style={{ wordWrap: 'break-word' }}>
                                <ListItemIcon>
                                    {cpf ? (
                                        <DoneIcon
                                            width={100}
                                        />
                                    ) :
                                        <ErrorIcon
                                            width={100}
                                        />
                                    }
                                </ListItemIcon>
                                <ListItemText>
                                    {!cpf ? ('CPF inválido') : cpf}
                                </ListItemText>
                            </ListItem>

                            <Typography color="secondary">
                                E-mail do Participante
                </Typography>
                            <ListItem style={{ wordWrap: 'break-word' }}>
                                <ListItemIcon>
                                    {email ? (
                                        <DoneIcon
                                            width={100}
                                        />
                                    ) :
                                        <ErrorIcon
                                            width={100}
                                        />
                                    }
                                </ListItemIcon>
                                <ListItemText>
                                    {!email ? ('Email inválido') : email}
                                </ListItemText>
                            </ListItem>
                        </List>
                    </div>
                </div>
            </Paper>
        </div>
    );
}

export default ThreeAsOne;